import { useState, useEffect, useMemo, useReducer } from "react";
import './Search.css'
import { Dropdown, Button, Modal } from "react-bootstrap";
import { PulseLoader } from "react-spinners";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { validEmail } from '../../Constants/RegExp';
import IconButton from '@mui/material/IconButton';
import CreateIcon from '@mui/icons-material/Create';
import { ToastContainer} from "react-toastify";
import MyAlert from '../../Components/Reusable/Alert/Alert';
import CustomButton from "../../Components/Reusable/Button/CustomButton";
import { usePagination } from "../../Components/Reusable/TablePagination/Functions";
import TablePaginationFooter from "../../Components/Reusable/TablePagination/TableFooter";
import BackButton from "../../Components/Reusable/BackButton/BackButton";
import { InlineDateTimeInputPro } from '../../Components/Reusable/Pickers';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { formatMinor } from "../../Components/Reusable/CurrencyFormatter/CurrencyFormatter";
import { DateTime } from "luxon";
import {
  GetCustomers,
  AddCustomer,
  GetAppointments,
  GetBarbers,
  GetServices,
  GetConfig,
  CancelAppointment,
  GetServiceDurations,
  GetEvents,
  EditAppointment,
  SendCommunication
} from './Requests';
import {
  notifySuccess,
  notifyError
} from '../../Response/ResposeHandler'
import dayjs from 'dayjs';
import Select from "react-select";
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const initialState = false;

const reducer = (state, action) =>{
  switch (action.type){
    case 'addCustomerOpen':
      return { ...state, addCustomer: true }
    case 'addCustomerClose':
      return { ...state, addCustomer: false }
    case 'appointmentsOpen':
      return { ...state, appointment: true }
    case 'appointmentsClose':
      return { ...state, appointment: false }
    case 'appointmentDetailsOpen':
      return { ...state, appointmentDetails: true }
    case 'appointmentDetailsClose':
      return { ...state, appointmentDetails: false }
    case 'sendCommunicationOpen':
      return { ...state, sendCommunication: true }
    case 'sendCommunicationClose':
      return { ...state, sendCommunication: false }
    case 'sendGeneralCommunicationOpen':
      return { ...state, sendGeneralCommunication: true }
    case 'sendGeneralCommunicationClose':
      return { ...state, sendGeneralCommunication: false }
    default:
      return state
  }
}

const daysOfWeekKeys = ['sun','mon','tue','wed','thu','fri','sat'];
const monthsKeys = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'];

const Search = () => {
  const { t, i18n } = useTranslation("search");

  // localized short day / month labels
  const daysOfWeek = useMemo(
    () => daysOfWeekKeys.map(k => t(`search.daysShort.${k}`)),
    [t, i18n.language]
  );
  const DaysToDisplay = daysOfWeek; // keep logic identical—use same array
  const months = useMemo(
    () => monthsKeys.map(k => t(`search.monthsShort.${k}`)),
    [t, i18n.language]
  );

  const [config, setConfig] = useState()
  const [state, dispatch] = useReducer(reducer, initialState);
  const [keyword, setKeyword] = useState("")
  const [showSearchButton, setShowSearchButton] = useState(false)
  const [isLoading, setIsloading] = useState(false)
  const [customers, setCustomer] = useState("")
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [mobile, setMobile] = useState();
  const [email, setEmail] = useState('');
  const [customerNotes, setCustomerNotes] = useState('');
  const [customerBlocked, setCustomerBlocked] = useState();
  let customerErrorsObj = { customerFirstName: '', customerLastName: '', customerMobile: '', customerEmail: '', customerNotes: '' };
  const [customerErrors, setCustomerErrors] = useState(customerErrorsObj);
  const [appointmentsLoading, setAppointmentsLoading] = useState(false)
  const [futureAppointments, setFutureAppointments] = useState([])
  const [allAppointments, setAllAppointments] = useState([])
  const [pastAppointments, setPastAppointments] = useState([])
  const [barbers, setBarbers]= useState([])
  const [services, setServices]= useState([])
  const [isAppointmentCancelled, setIsAppointmentCancelled] = useState();
  const [appointmentCancelledByMessage, setAppointmentCancelledByMessage] = useState();
  const [selectedBarber, setSelectedBarber] = useState();
  const [selectedService, setSelectedService] = useState();
  const [startDateTime, setStartDateTime] = useState();
  const [endDateTime, setEndDateTime] = useState();
  const [duration, setDuration] = useState();
  const [appointmentNotes, setAppointmentNotes] = useState('')
  const [cancelledBy, setCancelledBy] = useState()
  const [appointmentIdToEdit, setAppointmentIdToEdit] = useState();
  const [appointmentModalDisabled, setAppointmentModalDisabled] = useState(false)
  const [refundAmount, setRefundAmount] = useState(0)
  const [timeSelection, setTimeSelection] = useState([])
  let appointmentErrorsObj = { barber: '', service: '', date: '', duration: '', appointmentNotes: '', customer:'' };
  const [appointmentErrors, setAppointmentErrors] = useState(appointmentErrorsObj);
  const [minStep, setMinStep] = useState(20)
  const [customerDetailsObject, setCustomerDetailsObject] = useState()
  const [communicationType, setCommunicationType] = useState()
  const [customerAppointmentChangeMessage, setCustomerAppointmentChangeMessage] = useState()
  const [generalMessage, setGeneralMessage] = useState()
  const [barberList, setBarberList] = useState([])
  const [eventData, setEventData] = useState();
  const [customerSaveButtonLoading, setCustomerSaveButtonLoading] = useState(false)
  const [sendEmailButtonLoading, setSendEmailButtonLoading] = useState(false)
  const [paidAmount, setPaidAmount] = useState(0)
  const [cancellingAppointmentLoading, setCancellingAppointmentLoading] = useState(false)
  const [appointmentActionLoading, setAppointmentActionLoading] = useState(false)

  useEffect(() => {
    GetBarbersWrapper()
  }, []);

  const total = customers?.length ?? 0;
  const { page, setPage, pageSize, setPageSize, start, end, canPrev, canNext } =
    usePagination(total);
  const paged = useMemo(() => (customers ? customers.slice(start, end) : []), [customers, start, end]);

  function GetBarbersWrapper()
  {
    GetBarbers().then((res) => {
      setBarbers(res.data)
      var barberListArray = []
      res.data.forEach(element => {
        var obj = { value: element.barberId, label: element.name, isDisabled: element.status === 1 ? false : true }
        barberListArray.push(obj)
      });
      setBarberList(barberListArray)
    }).catch(() => {
    }).finally(() => {
      GetServicesWrapper()
    })
  }

  function GetServicesWrapper()
  {
    GetServices().then((res) => {
      var tempVar = []
      // eslint-disable-next-line
      res.data.map((item) => {
        var obj = { value: item.serviceId, label: item.name, duration: item.duration, price:item.price, acceptOnlinePayment: item.acceptOnlinePayment, isDisabled: item.status === 1 ? false : true }
        tempVar.push(obj)
      })
      setServices(tempVar)
    }).catch(() => {
    }).finally(() => {
      GetServiceDurationsWrapper()
    })
  }

  function GetServiceDurationsWrapper() {
    GetServiceDurations().then((res) => {
      setTimeSelection(res.data)
    }).catch(() => {
      notifyError(t('search.toasts.serviceDurationsLoadError'))
    }).finally(() => {
      GetConfigWrapper()
    })
  }

  function GetConfigWrapper() {
    GetConfig().then((res) => {
      setConfig(res.data)
      if (res.data.durationBlock === 1) setMinStep(10)
      if (res.data.durationBlock === 2) setMinStep(15)
      if (res.data.durationBlock === 3) setMinStep(20)
    }).catch(() => {
    }).finally(() => {
      // left as-is
    })
  }

  function GetEventsWrapper(barbers, queryDate, services) {
    var starts = []
    var ends = []
    var eventss = []
    barbers.forEach((barber, index) => {
      const fullDaysOfWeek = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday']
      const day = fullDaysOfWeek[new Date(queryDate).getDay()]
      var startTime = barber[day].start
      const endTime = barber[day].end
      var eventt = {}
      if (startTime !== null && endTime !== null)
      {
        if (parseInt(startTime.split(':')[0]) !== Math.min.apply(0, starts))
        {
          eventt = {
            id : index,
            eventId: index,
            eventType: 'CalendarBlockOut',
            title: '5',
            start: new Date(new Date(queryDate).setHours(0,0,0,0)),
            end: new Date(new Date(queryDate).setHours(parseInt(startTime.split(':')[0]),0,0,0)),
            resourceId: barber.barberId,
            isCalanderBlock: true,
            isResizable: false,
            isDraggable: false,
            colorEvento: '#dedede'
          }
          eventss.push(eventt)
        }
        if (parseInt(endTime.split(':')[0]) !== Math.max.apply(0, ends))
        {
          eventt = {
            id : index,
            eventId: index,
            eventType: 'CalendarBlockOut',
            title: '',
            start:new Date(new Date(queryDate).setHours(parseInt(endTime.split(':')[0]),0,0,0)),
            end: new Date(new Date(queryDate).setHours(23,40,0,0)),
            resourceId: barber.barberId,
            isCalanderBlock: true,
            isResizable: false,
            isDraggable: false,
            colorEvento: '#dedede'
          }
          eventss.push(eventt)
        }

      } else {
        eventt = {
          id : index,
          eventId: index,
          eventType: 'CalendarBlockOut',
          title: 'null',
          start: new Date(new Date(queryDate).setHours(0,0,0,0)),
          end: new Date(new Date(queryDate).setHours(23,59,0,0)),
          resourceId: barber.barberId,
          isCalanderBlock: true,
          isResizable: false,
          isDraggable: false,
          colorEvento: '#dedede'
        }
        eventss.push(eventt)
      }

    })

    GetEvents(queryDate).then((res) => {
      res.data.forEach((event) => {
        var color = barbers.filter(x => x.barberId === event.barberId)[0].barberColour
        var eventt = {
          id : event.eventId,
          eventId: event.eventId,
          allDay:false,
          eventType: event.eventType,
          title: event.cancelled
            ? t('search.labels.cancelled_label')
            : event.eventType === 3
              ? event.recurringFrequency === null
                ? event.title
                : String.fromCodePoint(8620) + ' ' + event.title
              : event.eventType === 2
                ? event.title
                : ((event.isFirstAppointment ? String.fromCodePoint(9733) + ' ' : '') + (event.appointmentNotes !== "" | event.customerNotes !== "" ? String.fromCodePoint(9998) + " " : "" )) + event.firstName + ' - ' + services.filter(x => x.value === event.serviceId)[0].label,
          serviceId: event.serviceId,
          appointmentNotes: event.appointmentNotes,
          isFirstAppointment: event.isFirstAppointment,
          cancelled: event.cancelled,
          cancelledBy: event.cancelledBy,
          cancelledAtUtc: event.cancelledAtUtc,
          customerId: event.customerId,
          firstName: event.firstName,
          lastName: event.lastName,
          phoneNumber: event.phoneNumber,
          email: event.email,
          customerNotes: event.customerNotes,
          customerBlocked: event.blocked,
          start: new Date(event.startDateTime),
          end: new Date(event.endDateTime),
          recurrenceStartDate: event.recurrenceStartDate,
          recurringFrequency: event.recurringFrequency,
          endReccurrenceDate: event.endReccurrenceDate,
          resourceId: event.barberId,
          isCalanderBlock: false,
          isResizable: true,
          isDraggable: !event.cancelled,
          colorEvento: event.cancelled ? 'rgba(190, 190, 190, 0.5)' : event.eventType === 1 ? "#" + color : event.eventType === 2 ?  'pink' : event.eventType === 3 ? 'pink' : 'grey'
        }

        eventss.push(eventt)
      })
      setEventData(eventss)
    }).catch(() => {
      notifyError(t('search.toasts.eventsLoadError'))
    }).finally(() => {
      hasOverlap(eventss.filter(x => x.eventType === 1), barbers);
    })
  }

  function hasOverlap(events, barbers) {
    var barberIds = []
    if (events.lenth !== 0)
    {
      barbers.forEach(barber => {
        var barberFilteredEvent = events.filter(x => x.resourceId === barber.barberId)
        const sorted = barberFilteredEvent.slice().sort((a, b) => new Date(a.start) - new Date(b.start));
        for (let i = 0; i < sorted.length - 1; i++) {
          const currentEnd = new Date(sorted[i].end);
          const nextStart = new Date(sorted[i + 1].start);
          if (currentEnd > nextStart) {
            barberIds.push(sorted[i].resourceId)
            break;
          }
        }
      });
    }
  }

  function eventClashChecker (eventsToCheck, startDate, endDate) {
    var clashedEvents = []
    eventsToCheck.forEach((elem)=>{
      const test = !((moment(endDate).diff(moment(elem.start))) <= 0 ||
        (moment(startDate).diff(moment(elem.end))) >= 0);
      if (test) {
        clashedEvents.push(elem)
      }
    })
    return clashedEvents
  }

  const handleSearch = () => {
    if (keyword !== null && keyword !== undefined && keyword !== "") {
      setIsloading(true)
      GetCustomers(keyword).then((res) => {
        setCustomer(res.data)
      }).catch(() => {
      }).finally(() => {
        setIsloading(false)
      })
    } else {
      setCustomer("")
    }
  };

  function KeywordHandler(e)
  {
    setKeyword(e.target.value)
    if (e.target.value === "") setShowSearchButton(false)
    else setShowSearchButton(true)
  }

  function loadCustomerDetails(customerId) {
    resetCustomerModal()
    var customer = customers.filter(x => x.customerId === customerId)[0]
    setFirstName(customer.customerFirstName)
    setLastName(customer.customerLastName)
    setEmail(customer.customerEmail)
    setMobile(customer.customerMobile)
    setCustomerNotes(customer.customerNotes)
    setCustomerBlocked(customer.customerIsBlocked)
    setCustomerErrors(customerErrorsObj)
  }

  function OnCustomerSubmitClick(e)
  {
    e.preventDefault();
    let error = false;
    const customerErrorObj = { ...customerErrorsObj };

    if (firstName === '') {
      customerErrorObj.customerFirstName = t('search.errors.customer.firstNameRequired');
      error = true;
    }

    if (lastName === '') {
      customerErrorObj.customerLastName = t('search.errors.customer.lastNameRequired');
      error = true;
    }

    if(mobile !== undefined && mobile !== null) {
      if (mobile.length > 0) {
        if (mobile.length !== 11) {
          customerErrorObj.customerMobile = t('search.errors.customer.invalidMobile');
          error = true;
        }
      }
    }

    if (email === '') {
      customerErrorObj.customerEmail = t('search.errors.customer.emailRequired');
      error = true;
    } else {
      if (!validEmail.test(email)) {
        customerErrorObj.customerEmail = t('search.errors.customer.invalidEmail');
        error = true;
      }
    }

    setCustomerErrors(customerErrorObj);
    if (error) {
      return;
    } else {
      setCustomerSaveButtonLoading(true)
      AddCustomer(
        firstName,
        lastName,
        mobile,
        email,
        customerNotes,
        customerBlocked,
      ).then(() => {
        notifySuccess(t('search.toasts.customerSaved'))
        dispatch({type:'addCustomerClose'})
      }).catch(() => {
        notifyError(t('search.toasts.createCustomerError'))
      }).finally(() => {
        handleSearch()
        resetCustomerModal()
        setCustomerSaveButtonLoading(false)
      })
    }
  }

  function resetCustomerModal() {
    setFirstName('')
    setLastName('')
    setMobile()
    setEmail('')
    setCustomerNotes('')
    setCustomerErrors(customerErrorsObj)
    setCustomerBlocked()
    setCustomerDetailsObject()
  }

  function LoadAppointments(customerId)
  {
    var customer = customers.filter(x => x.customerId === customerId)[0]
    var newCustomerObject = {firstName:customer.customerFirstName, lastName:customer.customerLastName, mobile:customer.customerMobile, email:customer.customerEmail, notes:customer.customerNotes, isBlocked:customer.customerBlocked, customerId: customerId}
    setCustomerDetailsObject(newCustomerObject)
    setPastAppointments([])
    setPastAppointments([])
    setAppointmentsLoading(true)
    GetAppointments(customerId).then((res) => {
      setAllAppointments(res.data)
      setFutureAppointments(res.data.filter(x => new Date(DateTime.fromISO(x.endDateTime, {zone: "utc"}).setZone(config.timeZone).toString().split("+")[0]) > new Date()))
      setPastAppointments(res.data.filter(x => new Date(DateTime.fromISO(x.endDateTime, {zone: "utc"}).setZone(config.timeZone).toString().split("+")[0]) < new Date()))
      setAppointmentsLoading(false)
    }).catch(() => {
    }).finally(() => {
    })
  }

  function LoadAppointmentDetails(appointmentId)
  {
    var appointment = allAppointments.filter(x => x.appointmentId === appointmentId)[0]
    GetEventsWrapper(barbers, new Date(appointment.startDateTime), services)
    setIsAppointmentCancelled(appointment.cancelled)
    setAppointmentCancelledByMessage(
      appointment.cancelled
        ? t('search.labels.cancelledByOn', {
            by: appointment.cancelledBy,
            date: new Date(DateTime.fromISO(appointment.cancelledAtUtc, {zone: "utc"}).setZone(config.timeZone).toString().split("+")[0]).toLocaleDateString(),
            time: new Date(DateTime.fromISO(appointment.cancelledAtUtc, {zone: "utc"}).setZone(config.timeZone).toString().split("+")[0]).toLocaleTimeString()
          })
        : null
    )
    setSelectedBarber(barberList.filter(x => x.value === appointment.barberId)[0])
    setSelectedService(services.filter(x => x.value === appointment.serviceId)[0]);
    const startt = new Date(DateTime.fromISO(appointment.startDateTime, {zone: "utc"}).setZone(config.timeZone).toString().split("+")[0])
    const endd = new Date(DateTime.fromISO(appointment.endDateTime, {zone: "utc"}).setZone(config.timeZone).toString().split("+")[0])
    setStartDateTime(dayjs(startt))
    setEndDateTime(dayjs(endd))
    setPaidAmount(appointment.paidAmount)
    setDuration(timeSelection.filter(x => x.value === ((new Date(appointment.endDateTime).getTime() - new Date(appointment.startDateTime).getTime())/60000)/(config.durationBlock === 1 ? 10 : config.durationBlock === 2 ? 15 : 20))[0])
    setAppointmentNotes(appointment.appointmentNotes)
    setRefundAmount(appointment.refundAmount === null ? 0 : appointment.refundAmount)
    setCancelledBy(appointment.cancelledBy)
    setAppointmentIdToEdit(appointmentId)
    if (new Date() > new Date(DateTime.fromISO(appointment.endDateTime, {zone: "utc"}).setZone(config.timeZone).toString().split("+")[0])) {
      setAppointmentModalDisabled(true)
    } else {
      setAppointmentModalDisabled(false)
    }
    dispatch({type:'appointmentDetailsOpen'})
  }

  function onSubmitAppointmentClick(e) {
    setCommunicationType("appointment changed")
    let error = false;

    if (selectedBarber === undefined || selectedBarber === null) {
      appointmentErrorsObj.barber = t('search.errors.required');
      error = true;
    }

    if (selectedService === undefined || selectedService === null) {
      appointmentErrorsObj.service = t('search.errors.required');
      error = true;
    }

    if (startDateTime === undefined || startDateTime === null) {
      appointmentErrorsObj.date = t('search.errors.required');
      error = true;
    }
    if (duration === undefined || duration === null) {
      appointmentErrorsObj.duration = t('search.errors.required');
      error = true;
    }
    if (customerDetailsObject === null)
    {
      appointmentErrorsObj.customer = t('search.errors.addCustomer');
      error = true
    }
    setAppointmentErrors(appointmentErrorsObj);
    if (error) {
      return;
    } else {
      setAppointmentActionLoading(true)
      const calanderAppointmentsForBarber = eventData.filter(x => x.eventType === 1 && x.resourceId === selectedBarber.value && x.eventId !== appointmentIdToEdit)
      const clashedEvents = eventClashChecker(calanderAppointmentsForBarber, new Date(startDateTime), new Date(endDateTime))
      if (clashedEvents.length > 0){
        MyAlert.fire({
          icon: 'error',
          title: t('search.alerts.appointmentClashTitle'),
          html: `${t('search.alerts.clashIntro')} <b>` + clashedEvents.map((clashedEvent) => {
            return '<br/>' + clashedEvent.title + '&nbsp &nbsp'
              + ("0" + new Date(clashedEvent.start).getUTCHours()).slice(-2) + ':'
              + ("0" + new Date(clashedEvent.start).getUTCMinutes()).slice(-2) + ' - '
              + ("0" + new Date(clashedEvent.end).getUTCHours()).slice(-2) + ':'
              + ("0" + new Date(clashedEvent.end).getUTCMinutes()).slice(-2)
          })
        })
      } else {
        const blockOutForBarber = eventData.filter(x => x.eventType === 'CalendarBlockOut' && x.resourceId === selectedBarber.value && x.eventId !== appointmentIdToEdit)
        const clashedEvents2 = eventClashChecker(blockOutForBarber, new Date(startDateTime), new Date(endDateTime))
        if (clashedEvents2.length > 0) {
          MyAlert.fire({
            icon: 'error',
            title: t('search.alerts.barberNotWorkingTitle'),
            html: t('search.alerts.chooseDifferentBarber')
          })
        }
        else{
          const createdBy = "Barber Shop";
          const calanderHolidaysForBarber = eventData.filter(x => (x.eventType === 2 || x.eventType === 3)  && x.resourceId === selectedBarber.value)
          const clashedWithHolidays = eventClashChecker(calanderHolidaysForBarber, new Date(startDateTime), new Date(endDateTime))
          if (clashedWithHolidays.length > 0){
            MyAlert.fire({
              title: t('search.alerts.editAppointmentConfirm'),
              text: t('search.alerts.holidayDuringAppointment'),
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: 'var(--primary)',
              cancelButtonColor: '#aaa',
              confirmButtonText: t('search.actions.changeHoliday')
            }).then((result) => {
              if (result.isConfirmed) {
                EditAppointment(
                  appointmentIdToEdit,
                  customerDetailsObject.customerId,
                  selectedBarber.value,
                  selectedService.value,
                  startDateTime,
                  endDateTime,
                  duration.value,
                  appointmentNotes,
                  customerDetailsObject.firstName,
                  customerDetailsObject.lastName,
                  customerDetailsObject.mobile,
                  customerDetailsObject.email,
                  customerDetailsObject.notes,
                  customerDetailsObject.isBlocked,
                  createdBy,
                  true
                ).then(() => {
                  notifySuccess(t('search.toasts.appointmentEdited'))
                  dispatch({type:'appointmentDetailsClose'})
                  resetAppointmentModal()
                  OpenSendCommunicationModal("appointment changed")
                  handleSearch()
                  LoadAppointments(customerDetailsObject.customerId)
                }).catch(() => {
                  notifyError(t('search.toasts.unableAddAppointment'))
                }).finally(() => {
                  setAppointmentActionLoading(false)
                })
              }
            })
          } else {
            EditAppointment(
              appointmentIdToEdit,
              customerDetailsObject.customerId,
              selectedBarber.value,
              selectedService.value,
              startDateTime,
              endDateTime,
              duration.value,
              appointmentNotes,
              customerDetailsObject.firstName,
              customerDetailsObject.lastName,
              customerDetailsObject.mobile,
              customerDetailsObject.email,
              customerDetailsObject.notes,
              customerDetailsObject.isBlocked,
              createdBy
            ).then(() => {
              notifySuccess(t('search.toasts.appointmentEdited'))
              dispatch({type:'appointmentDetailsClose'})
              resetAppointmentModal()
              handleSearch()
              LoadAppointments(customerDetailsObject.customerId)
              OpenSendCommunicationModal("appointment changed")
            }).catch(() => {
              notifyError(t('search.toasts.unableAddAppointment'))
            }).finally(() => {
              setAppointmentActionLoading(false)
            })
          }
        }
      }
    }
  }

  function selectServiceHandler(e) {
    setSelectedService({value:e.value ,label: e.label});
    setDuration(timeSelection.filter(x => x.value === e.duration)[0])
    addDuration(timeSelection.filter(x => x.value === e.duration)[0])
  }

  function addDuration(duration) {
    setDuration(duration)
    if (startDateTime !== undefined && startDateTime !== null) {
      var endDateTimeValue = new Date(startDateTime)
      var mins = 0
      if (config.durationBlock === 1) mins = duration.value * 10
      if (config.durationBlock === 2) mins = duration.value * 15
      if (config.durationBlock === 3) mins = duration.value * 20
      endDateTimeValue.setMinutes(endDateTimeValue.getMinutes() + mins)
      setEndDateTime(endDateTimeValue)
    }
  }

  function startDateHandler(e) {
    setStartDateTime(new Date(e))
    if (duration !== undefined) {
      var endDateTimeValue = new Date(e)
      var mins = 0
      if (config.durationBlock === 1) mins = duration.value * 10
      if (config.durationBlock === 2) mins = duration.value * 15
      if (config.durationBlock === 3) mins = duration.value * 20
      endDateTimeValue.setMinutes(endDateTimeValue.getMinutes() + mins)
      setEndDateTime(endDateTimeValue)
    }
  }

  function resetAppointmentModal() {
    resetCustomerModal()
    setSelectedBarber()
    setSelectedService()
    setStartDateTime()
    setEndDateTime()
    setDuration()
    setPaidAmount(0)
    setAppointmentNotes('')
    setRefundAmount(0)
    setAppointmentModalDisabled(false)
    setAppointmentErrors(appointmentErrorsObj)
    setCustomerDetailsObject(null)
  }

  function onCancelAppointment(cancelAppointmentOption) {
    MyAlert.fire({
      title: cancelAppointmentOption === 0 ? t('search.alerts.cancelAppointmentConfirm') : t('search.alerts.reinstateAppointmentConfirm'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'var(--primary)',
      cancelButtonColor: '#aaa',
      confirmButtonText: t('search.actions.yes'),
      cancelButtonText: t('search.actions.no')
    }).then((result) => {
      if (result.isConfirmed) {
        const cancelAppointmentBy = "Barber"
        setCancellingAppointmentLoading(true)
        CancelAppointment(
          appointmentIdToEdit,
          cancelAppointmentOption,
          cancelAppointmentBy
        ).then(() => {
          notifySuccess(t('search.toasts.appointmentCancelled'))
          dispatch({type:'AddAppointmentClose'})
          if (cancelAppointmentOption === 0) {
            setCommunicationType("appointment cancelled")
            OpenSendCommunicationModal("appointment cancelled")
          }
          dispatch({type:'appointmentDetailsClose'})
          handleSearch()
          LoadAppointments(customerDetailsObject.customerId)
        }).catch(() => {
          notifyError(t('search.toasts.unableCancelAppointment'))
        }).finally(() => {
          setCancellingAppointmentLoading(false)
        })
      }
    })
  }

  function OpenSendCommunicationModal(communicationType){
    if (communicationType === "appointment changed") {
      setCustomerAppointmentChangeMessage(config.appointmentChangedMessageToCustomer)
    }
    if (communicationType ===  "appointment cancelled") {
      setCustomerAppointmentChangeMessage(config.appointmentCancellationMessageToCustomer)
    }
    dispatch({type:'sendCommunicationOpen'})
  }

  function onSubmitSendCommunicationClick() {
    if (communicationType === "general message") {
      setSendEmailButtonLoading(true)
      SendCommunication(
        communicationType,
        customerDetailsObject.customerId,
        generalMessage
      ).then(() => {
        notifySuccess(t('search.toasts.emailSent'))
        dispatch({type:'sendGeneralCommunicationClose'})
        setCommunicationType()
      }).catch(() => {
        notifyError(t('search.toasts.emailSendError'))
      }).finally(() => {
        setSendEmailButtonLoading(false)
      })
    } else {
      setSendEmailButtonLoading(true)
      SendCommunication(
        communicationType,
        appointmentIdToEdit,
        customerAppointmentChangeMessage
      ).then(() => {
        notifySuccess(t('search.toasts.emailSent'))
        dispatch({type:'sendCommunicationClose'})
        setCommunicationType()
      }).catch(() => {
        notifyError(t('search.toasts.emailSendError'))
      }).finally(() => {
        setSendEmailButtonLoading(false)
      })
    }
  }

  function LoadGneralCommunication(customerId)
  {
    var customer = customers.filter(x => x.customerId === customerId)[0]
    var newCustomerObject = {firstName:customer.firstName, lastName:customer.lastName, mobile:customer.phoneNumber, email:customer.customerEmail, notes:customer.customerNotes, isBlocked:customer.customerBlocked, customerId: customerId}
    setCustomerDetailsObject(newCustomerObject)
    dispatch({type:'sendGeneralCommunicationOpen'});
    setCommunicationType('general message')
  }

  return (
    <div>
      <ToastContainer />

      <div className="search-controls">
        <div className="sm-search">
          <input
            type="text"
            className="sm-search__input"
            placeholder={t('search.placeholders.searchCustomers')}
            defaultValue={keyword}
            onChange={KeywordHandler}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSearch();
              }
            }}
          />

          <button
            type="button"
            className={`sm-search__btn ${!showSearchButton ? "is-disabled" : ""}`}
            onClick={handleSearch}
            disabled={!showSearchButton}
          >
            {t('search.actions.search')}
          </button>
        </div>

        <IconButton title={t('search.actions.addCustomer')} onClick={() => {dispatch({type:'addCustomerOpen'})}} aria-label="delete" size="large">
          <AddCircleOutlineIcon style={{ justifyContent: "right" }} />
        </IconButton>
      </div>

      <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
        <div style={{marginTop:"2rem"}}>
          <PulseLoader
            color={'#333'}
            loading={isLoading}
            size={25}
            aria-label={t('search.misc.loading')}
            data-testid="loader"
            style={{marginLeft:"auto"}}
          />
        </div>
      </div>

      {isLoading ? null :
        <div className="dashboard-container" style={{paddingTop:0, marginRight:"10px", gridTemplateColumns:"none"}}>
          <div className="data-table-wrapper">

            <table className="data-table">
              <thead>
                <tr>
                  <th>{t('search.table.headers.firstName')}</th>
                  <th>{t('search.table.headers.lastName')}</th>
                  <th>{t('search.table.headers.email')}</th>
                  <th>{t('search.table.headers.blocked')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {customers === "" ? null :
                  paged.map((customer, index) => (
                    <tr key={index}>
                      <td>{customer.customerFirstName}</td>
                      <td>{customer.customerLastName}</td>
                      <td>{customer.customerEmail}</td>
                      <td>{customer.customerIsBlocked ? t('search.common.yes') : t('search.common.no')}</td>
                      <td className="py-2 text-end">
                        <Dropdown autoClose={true} className="dropdown text-sans-serif">
                          <Dropdown.Toggle
                            variant=""
                            className="btn tp-btn-light sharp i-false"
                            type="button"
                            id="order-dropdown-0"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            drop="up"
                          >
                            <span>
                              <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="18px" height="18px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                  <rect y={0} width={24} height={24}/>
                                  <circle fill="#000000" cx={5} cy={12} r={2}/>
                                  <circle fill="#000000" cx={12} cy={12} r={2}/>
                                  <circle fill="#000000" cx={19} cy={12} r={2}/>
                                </g>
                              </svg>
                            </span>
                          </Dropdown.Toggle>
                          <Dropdown.Menu
                            align="end"
                            renderOnMount
                            popperConfig={{
                              strategy: 'fixed',
                              modifiers: [
                                { name: 'computeStyles', options: { adaptive: false } },
                                { name: 'preventOverflow', options: { boundary: 'viewport' } },
                                { name: 'flip', options: { fallbackPlacements: ['top', 'bottom'] } },
                              ],
                            }}
                            className="dropdown-menu dropdown-menu-right border py-0"
                            aria-labelledby="order-dropdown-0"
                          >
                            <Dropdown.Item className="dropdown-item" onClick={() => {dispatch({type:'addCustomerOpen'}); loadCustomerDetails(customer.customerId);}}>
                              {t('search.actions.viewCustomer')}
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => {dispatch({type:'appointmentsOpen'}); LoadAppointments(customer.customerId)}}>
                              {t('search.actions.viewAppointments')}
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => {LoadGneralCommunication(customer.customerId)}}>
                              {t('search.actions.sendMessage')}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {customers && customers.length > 8 ?
            <TablePaginationFooter
              total={total}
              page={page}
              pageSize={pageSize}
              setPage={setPage}
              setPageSize={setPageSize}
              canPrev={canPrev}
              canNext={canNext}
            /> : null}
        </div>
      }

      {customers === "" ? null :
        customers.length === 0
          ?
          <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
            <div style={{marginTop:"2rem"}}>
              <p className="sm-dull">{t('search.empty.noResults', { keyword })}</p>
            </div>
          </div>
          :
          null
      }

      <Modal className="modal fade" show={state.addCustomer} centered>
        <div className="sm-modal sm-modal--md">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{t('search.modals.customer.title')}</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => {dispatch({type:'addCustomerClose'}); resetCustomerModal();}}></Button>
          </div>
          <div className="sm-modal__body">
            <form className="sm-form" onSubmit={OnCustomerSubmitClick}>
              <div className="sm-grid sm-grid--2 sm-grid--gap">
                <div className={`sm-field ${customerErrors.customerFirstName ? "is-error" : ""}`}>
                  <label className="sm-label">
                    {t('search.labels.firstName')} <span className="sm-req">*</span>
                  </label>
                  <input
                    type="text"
                    className="sm-input"
                    name="customerFirstName"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                  {customerErrors.customerFirstName && (
                    <div className="sm-error">{customerErrors.customerFirstName}</div>
                  )}
                </div>

                <div className={`sm-field ${customerErrors.customerLastName ? "is-error" : ""}`}>
                  <label className="sm-label">
                    {t('search.labels.lastName')} <span className="sm-req">*</span>
                  </label>
                  <input
                    type="text"
                    className="sm-input"
                    name="customerLastName"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                  {customerErrors.customerLastName && (
                    <div className="sm-error">{customerErrors.customerLastName}</div>
                  )}
                </div>
                <div className={`sm-field ${customerErrors.customerMobile ? "is-error" : ""}`} style={{ gridColumn: "1 / -1" }}>
                  <label className="sm-label">{t('search.labels.mobile')}</label>
                  <input
                    type="tel"
                    className="sm-input"
                    name="customerMobile"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                  />
                  {customerErrors.customerMobile && (
                    <div className="sm-error">{customerErrors.customerMobile}</div>
                  )}
                </div>
                <div className={`sm-field ${customerErrors.customerEmail ? "is-error" : ""}`} style={{ gridColumn: "1 / -1" }}>
                  <label className="sm-label">
                    {t('search.labels.email')} <span className="sm-req">*</span>
                  </label>
                  <input
                    type="email"
                    className="sm-input"
                    name="customerEmail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {customerErrors.customerEmail && (
                    <div className="sm-error">{customerErrors.customerEmail}</div>
                  )}
                </div>
                <div className={`sm-field ${customerErrors.customerNotes ? "is-error" : ""}`} style={{ gridColumn: "1 / -1" }}>
                  <label className="sm-label">{t('search.labels.notes')}</label>
                  <textarea
                    rows={6}
                    className="sm-textarea"
                    name="customerNotes"
                    value={customerNotes}
                    maxLength={250}
                    onChange={(e) => setCustomerNotes(e.target.value)}
                  />
                  {customerErrors.customerNotes && (
                    <div className="sm-error">{customerErrors.customerNotes}</div>
                  )}
                </div>
                <div className="sm-field" style={{ gridColumn: "1 / -1" }}>
                  <label className="sm-label">{t('search.labels.status')}</label>
                  <label className="sm-check">
                    <input
                      type="checkbox"
                      className="sm-check__input"
                      id="isBlocked"
                      checked={!!customerBlocked}
                      onChange={(e) => setCustomerBlocked(e.target.checked)}
                    />
                    <span className="sm-check__box" aria-hidden="true"></span>
                    <span className="sm-check__label">{t('search.labels.blocked')}</span>
                  </label>
                </div>
              </div>
              <div className="sm-actions">
                <CustomButton className="app-btn--sm" onClick={OnCustomerSubmitClick} label={t('search.actions.save')} loading={customerSaveButtonLoading} />
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal className="modal fade" show={state.appointment} centered>
        <div className="sm-modal">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{t('search.modals.appointments.title')}</h5>
            <Button
              variant=""
              type="button"
              className="btn-close"
              data-dismiss="modal"
              onClick={() => { dispatch({ type: 'appointmentsClose' }); }}
            />
          </div>

          <div className="sm-modal__body">
            <form onSubmit={OnCustomerSubmitClick}>
              {appointmentsLoading ? (
                <div className="sm-loader">
                  <PulseLoader
                    color={'#333'}
                    loading={appointmentsLoading}
                    size={12}
                    aria-label={t('search.misc.loading')}
                    data-testid="loader"
                  />
                </div>
              ) : (
                <>
                  <section>
                    <h6 className="sm-section__title">{t('search.labels.futureAppointments')}</h6>
                    {futureAppointments.length === 0 ? (
                      <div className="sm-empty">{t('search.labels.noAppointments')}</div>
                    ) : (
                      <ul className="sm-list sm-list--appointments">
                        {futureAppointments.map((appointment) => {
                          const barberName =
                            barbers.find((x) => x.barberId === appointment.barberId)?.name || t('search.common.dash');

                          const dateStr = `${DaysToDisplay[new Date(appointment.startDateTime).getDay()]} ${new Date(appointment.startDateTime).getDate()} ${months[new Date(appointment.startDateTime).getMonth()]} ${new Date(appointment.startDateTime).getFullYear()}`;

                          return (
                            <li
                              key={appointment.appointmentId}
                              className={`sm-listItem ${appointment.cancelled ? 'is-cancelled' : ''}`}
                            >
                              <div className="sm-listItem__main">
                                <div className="sm-listItem__title">
                                  {appointment.firstAppointment ? (
                                    <span className="sm-star" aria-hidden="true">★ </span>
                                  ) : null}
                                  {barberName}
                                </div>

                                <div className="sm-listItem__meta">
                                  <span className="sm-date">
                                    <span className="date-btn__text">
                                      {new Intl.DateTimeFormat(i18n.language || "en", { weekday: "short", day: "2-digit", month: "short" })
                                        .format(new Date(appointment.startDateTime)).replace(/,/g, "")}
                                    </span>
                                  </span>
                                  {appointment.cancelled && (
                                    <span className="sm-badge sm-badge--danger">{t('search.labels.cancelled_label')}</span>
                                  )}
                                </div>
                              </div>

                              <IconButton className="icon-btn" onClick={() => { LoadAppointmentDetails(appointment.appointmentId); }} aria-label="delete" size="large">
                                <CreateIcon fontSize="small"/>
                              </IconButton>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </section>

                  <section className="sm-section">
                    <h6 className="sm-section__title">{t('search.labels.pastAppointments')}</h6>

                    {pastAppointments.length === 0 ? (
                      <div className="sm-empty">{t('search.labels.noAppointments')}</div>
                    ) : (
                      <ul className="sm-list sm-list--appointments is-muted">
                        {pastAppointments.map((appointment) => {
                          const barberName =
                            barbers.find((x) => x.barberId === appointment.barberId)?.name || t('search.common.dash');

                          const dateStr = `${DaysToDisplay[new Date(appointment.startDateTime).getDay()]} ${new Date(appointment.startDateTime).getDate()} ${months[new Date(appointment.startDateTime).getMonth()]} ${new Date(appointment.startDateTime).getFullYear()}`;

                          return (
                            <li key={appointment.appointmentId} className="sm-listItem">
                              <div className="sm-listItem__main">
                                <div className="sm-listItem__title">{barberName}</div>
                                <div className="sm-listItem__meta">
                                  <span className="sm-date">
                                    <span className="date-btn__text">
                                      {new Intl.DateTimeFormat(i18n.language || "en", { weekday: "short", day: "2-digit", month: "short" })
                                        .format(new Date(appointment.startDateTime)).replace(/,/g, "")}
                                    </span>
                                  </span>
                                </div>
                              </div>
                              <IconButton className="icon-btn" onClick={() => { LoadAppointmentDetails(appointment.appointmentId); }} aria-label="delete" size="large">
                                <CreateIcon fontSize="small"/>
                              </IconButton>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </section>
                </>
              )}
            </form>
          </div>
        </div>
      </Modal>

      <Modal enforceFocus={false} className="modal fade" show={state.appointmentDetails} centered>
        <div className="sm-modal">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{t('search.modals.editAppointment.title')}</h5>
            <IconButton aria-label="delete" size="large">
              <ArrowBackIcon className="customer-modal-back-arrow"
                onClick={() => {
                  dispatch({type:'appointmentDetailsClose'})
                }}/>
            </IconButton>
          </div>

          <div className="sm-modal__body">
            <form className="sm-form" onSubmit={onSubmitAppointmentClick}>
              <div className="sm-grid sm-grid--2">
                <div className={`sm-field ${appointmentErrors.barber ? "is-error" : ""}`}>
                  <label className="sm-label">
                    {t('search.labels.selectStaff')} <span className="sm-req">*</span>
                  </label>
                  <Select
                    isSearchable={false}
                    placeholder={t('search.placeholders.staff')}
                    closeMenuOnSelect
                    options={barberList}
                    defaultValue={selectedBarber}
                    isDisabled={isAppointmentCancelled || appointmentModalDisabled}
                    onChange={(e) =>
                      setSelectedBarber({
                        value: e.value,
                        label: e.label,
                        workingDayArray: e.workingDayArray,
                      })
                    }
                    className="sm-select"
                    classNamePrefix="rs"
                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                  {appointmentErrors.barber && <div className="sm-error">{appointmentErrors.barber}</div>}
                </div>

                <div className={`sm-field ${appointmentErrors.service ? "is-error" : ""}`}>
                  <label className="sm-label">
                    {t('search.labels.selectService')} <span className="sm-req">*</span>
                  </label>
                  <Select
                    isSearchable={false}
                    placeholder={t('search.placeholders.services')}
                    closeMenuOnSelect
                    options={services}
                    defaultValue={selectedService}
                    isDisabled={isAppointmentCancelled || appointmentModalDisabled}
                    onChange={selectServiceHandler}
                    className="sm-select"
                    classNamePrefix="rs"
                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                  {appointmentErrors.service && <div className="sm-error">{appointmentErrors.service}</div>}
                </div>

                <div className={`sm-field sm-field--spaced ${appointmentErrors.date ? "is-error" : ""}`}>
                  <InlineDateTimeInputPro
                    label={t('search.labels.chooseDate')}
                    required
                    value={startDateTime}
                    onChange={(d) => startDateHandler(d)}
                    minuteStep={minStep}
                    disablePast={true}
                    disabled={isAppointmentCancelled || appointmentModalDisabled}
                    isDateAllowed={(jsDate) => {
                      if (!selectedBarber?.workingDayArray) return true;
                      const dayIndex = jsDate.getDay(); // 0..6
                      return selectedBarber.workingDayArray.some(d => d - 1 === dayIndex);
                    }}
                  />
                  {appointmentErrors.date && <div className="sm-error">{appointmentErrors.date}</div>}
                </div>

                <div className={`sm-field sm-field--spaced ${appointmentErrors.duration ? "is-error" : ""}`}>
                  <label className="sm-label">
                    {t('search.labels.duration')} <span className="sm-req">*</span>
                  </label>
                  <Select
                    isSearchable={false}
                    closeMenuOnSelect
                    options={timeSelection}
                    value={duration}
                    isDisabled={isAppointmentCancelled || appointmentModalDisabled}
                    onChange={addDuration}
                    className="sm-select"
                    classNamePrefix="rs"
                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                  {appointmentErrors.duration && <div className="sm-error">{appointmentErrors.duration}</div>}
                </div>
              </div>

              <div className="sm-field sm-field--spaced">
                <label className="sm-label">{t('search.labels.notes')}</label>
                <textarea
                  rows={6}
                  className="sm-textarea"
                  name="customerNotes"
                  disabled={isAppointmentCancelled || appointmentModalDisabled}
                  value={appointmentNotes}
                  maxLength={250}
                  onChange={(e) => setAppointmentNotes(e.target.value)}
                />
                {appointmentErrors.appointmentNotes && (
                  <div className="sm-error">{appointmentErrors.appointmentNotes}</div>
                )}
              </div>

              <div className="sm-section">
                <div className="sm-section__head">{t('search.labels.appointmentSummary')}</div>
                <ul className="sm-list">
                  {(startDateTime !== undefined && endDateTime !== undefined && duration !== undefined) ? (
                    <li>
              <span className="sm-list__label">{t('search.labels.date')}:</span>
                <span className="sm-list__value">
              <span className="date-btn__text">
                {new Intl.DateTimeFormat(i18n.language || "en", { weekday: "short", day: "2-digit", month: "short" })
                  .format(startDateTime).replace(/,/g, "")}
              </span>
              <span> </span>
                <span className="date-btn__text">
                {new Intl.DateTimeFormat(i18n.language || "en", { hour: "2-digit", minute:"2-digit" })
                  .format(startDateTime)}
              </span>
              <span>-</span>
                <span className="date-btn__text">
                {new Intl.DateTimeFormat(i18n.language || "en", { hour: "2-digit", minute:"2-digit" })
                  .format(endDateTime)}
              </span>
                </span>
                    </li>
                  ) : (
                    <li>
                      <span className="sm-list__label">{t('search.labels.date')}:</span>
                      <span className="sm-list__value">
                        {t('search.common.dash')}
                      </span>
                    </li>
                  )}
                  <li>
                    <span className="sm-list__label">{t('search.labels.name')}:</span>
                    <span className="sm-list__value">
                      {customerDetailsObject
                        ? `${customerDetailsObject.firstName} ${customerDetailsObject.lastName}`
                        : t('search.common.dash')}
                    </span>
                  </li>
                  <li>
                    <span className="sm-list__label">{t('search.labels.email')}:</span>
                    <span className="sm-list__value">
                      {customerDetailsObject ? customerDetailsObject.email : t('search.common.dash')}
                    </span>
                  </li>
                  {selectedService !== undefined && (
                    services.filter(x => x.value === selectedService.value)[0].acceptOnlinePayment ? (
                      <>
                        <li>
                          <span className="sm-list__label">{t('search.labels.paidOnline')}:</span>
                          <span className="sm-list__value">
                            {formatMinor(paidAmount, config.currency)}
                          </span>
                        </li>
                        <li>
                          <span className="sm-list__label">{t('search.labels.payAtAppointment')}:</span>
                          <span className="sm-list__value">
                            {formatMinor(services.filter(x => x.value === selectedService.value)[0].price - paidAmount, config.currency)}
                          </span>
                        </li>
                        <li>
                          <span className="sm-list__label">{t('search.labels.refunded')}:</span>
                          <span className="sm-list__value">
                            {refundAmount.toString() === "-1" ? <span style={{color:"red"}}>{t('search.labels.failed')}</span> : formatMinor(refundAmount, config.currency)}
                          </span>
                        </li>
                      </>
                    ) : (
                      <li>
                        <span className="sm-list__label">{t('search.labels.payAtAppointment')}:</span>
                        <span className="sm-list__value">
                          {formatMinor(services.filter(x => x.value === selectedService.value)[0].price, config.currency)}
                        </span>
                      </li>
                    )
                  )}
                  <li>{appointmentCancelledByMessage && <p className="sm-footnote">{appointmentCancelledByMessage}</p>}</li>
                </ul>
              </div>

              <div className="sm-form__footer">
                <div className="sm-flex-between">
                  <div>
                    {(!isAppointmentCancelled && !appointmentModalDisabled) ? (
                      <BackButton label={t('search.actions.cancel')} loading={cancellingAppointmentLoading} onClick={() => onCancelAppointment(0)}> </BackButton>
                    ) : (cancelledBy === "Barber" && !appointmentModalDisabled) ? (
                      <BackButton label={t('search.actions.reinstate')} onClick={() => onCancelAppointment(1)} loading={cancellingAppointmentLoading}> </BackButton>
                    ) : null}
                  </div>
                  <div>
                    {(!isAppointmentCancelled && !appointmentModalDisabled) && (
                      <CustomButton className="app-btn--sm" onClick={onSubmitAppointmentClick} label={t('search.actions.editAppointment')} loading={appointmentActionLoading} />
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal enforceFocus={false} className="modal fade" show={state.sendCommunication} centered>
        <div className="sm-modal">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{t('search.modals.sendCommunication.title')}</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => {dispatch({type:'sendCommunicationClose'}); setCommunicationType();}}></Button>
          </div>
          <div className="sm-modal__body">
            <form className="sm-form" onSubmit={onSubmitSendCommunicationClick}>
              <div className="row mb-3">
                <div className="mt-2 col-lg-12">
                  <div className={`sm-field`} style={{ gridColumn: "1 / -1" }}>
                    <label className="sm-label mb-2">{t('search.labels.message')}</label>
                    <textarea
                      rows={7}
                      className="sm-textarea"
                      name=""
                      defaultValue={customerAppointmentChangeMessage}
                      maxLength={500}
                      placeholder=""
                      onChange={(e) => setCustomerAppointmentChangeMessage(e.target.value)}
                    />
                  </div>
                  {communicationType === "appointment changed"
                    ? <span>
                        <p style={{fontSize:'0.9rem'}}>{t('search.labels.emailIncludesNewDetails')}</p>
                        <p style={{fontSize:'0.9rem'}}>{t('search.labels.emailNoticeGeneric', { email: customerDetailsObject === undefined ? '' : customerDetailsObject.email })}</p>
                      </span>
                    : <p style={{fontSize:'0.9rem'}}>{t('search.labels.emailNoticeGeneric', { email: customerDetailsObject === undefined ? '' : customerDetailsObject.email })}</p>}
                </div>
              </div>
              <div className="sm-actions">
                <CustomButton className="app-btn--sm" onClick={onSubmitSendCommunicationClick} label={t('search.actions.sendEmail')} loading={sendEmailButtonLoading} />
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal enforceFocus={false} className="modal fade" show={state.sendGeneralCommunication} centered>
        <div className="sm-modal">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{t('search.modals.sendCommunication.title')}</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => {dispatch({type:'sendGeneralCommunicationClose'}); setCommunicationType();}}></Button>
          </div>
          <div className="sm-modal__body">
            <form className="sm-form" onSubmit={onSubmitSendCommunicationClick}>
              <div className="row mb-3">
                <div className="mt-2 col-lg-12">
                  <div className={`sm-field`} style={{ gridColumn: "1 / -1" }}>
                    <label className="sm-label mb-2">{t('search.labels.message')}</label>
                    <textarea
                      rows={7}
                      className="sm-textarea"
                      name=""
                      maxLength={500}
                      placeholder=""
                      onChange={(e) => setGeneralMessage(e.target.value)}
                    />
                  </div>
                  <p style={{fontSize:'0.9rem'}}>{t('search.labels.emailNoticeGeneric', { email: customerDetailsObject === undefined ? '' : customerDetailsObject.email })}</p>
                </div>
              </div>
              <div className="sm-actions">
                <CustomButton className="app-btn--sm" onClick={onSubmitSendCommunicationClick} label={t('search.actions.sendEmail')} loading={sendEmailButtonLoading} />
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Search;
